import React from "react";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import Tooltip from "@mui/material/Tooltip";
import ButtonBase from "@mui/material/ButtonBase";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const MAX_HEIGHT = 44;

const StyledButtonBase = styled(ButtonBase)(({ theme }) => ({
  height: MAX_HEIGHT,
  [theme.breakpoints.up("sm")]: {
    height: MAX_HEIGHT,
  },
}));

const StyledImage = styled("img")(({ theme }) => ({
  flexShrink: 0,
  flexGrow: 0,
  maxHeight: MAX_HEIGHT,
  maxWidth: 200,
  // width: "100%",
  borderRadius: 0,
  display: "block",
  margin: 0,
  border: 0,
  [theme.breakpoints.up("sm")]: {
    maxHeight: MAX_HEIGHT,
  },
}));

export default function HeaderLogo({ arena }) {
  const onClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <>
      {arena.logo && (
        <Helmet>
          <link rel="preload" href={arena.logo.url} as="image" />
        </Helmet>
      )}
      <Tooltip title={arena.title}>
        <StyledButtonBase component={Link} to="/" onClick={onClick}>
          {arena.logo ? (
            <StyledImage src={arena.logo.url} alt={arena.title} />
          ) : (
            arena.title
          )}
        </StyledButtonBase>
      </Tooltip>
    </>
  );
}

HeaderLogo.propTypes = {
  arena: PropTypes.shape({
    title: PropTypes.string.isRequired,
    logo: PropTypes.shape({
      url: PropTypes.string,
    }),
  }),
};
